module.exports = __webpack_public_path__ + "0675baffd7513474d51395cec3dcdbf2.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-90.cur
// module id = 484
// module chunks = 0